import employer from "./employer";
import employers from "./employers";
import host from "./host";
import matchings from "./matchings";

export const expo = {
    employer,
    employers,
    host,
    matchings,
};

export default expo;
